import { SvgIcon, type SvgIconProps } from "@mui/material";

const Cycle = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px">
        <path fill="currentColor" d="M339.33-105q-114-42.67-186.66-143.67-72.67-101-72.67-231 0-30 3.83-59.66Q87.67-569 97-597.67L39-564 5.67-621l179-103.33 103.33 178L230-513l-56.67-97.33q-13 31-19.83 63.66-6.83 32.67-6.83 67 0 109.67 63.33 195.84 63.33 86.16 163.33 120.16l-34 58.67Zm294-508.33V-680h113Q699-743 629-778.17q-70-35.16-149-35.16-64.33 0-120.33 22.33t-100.34 62l-34-59.33q52.67-43 117.34-67.34Q407.33-880 480-880q85 0 160.67 33.5Q716.33-813 773.33-751v-69H840v206.67H633.33ZM594.67 0l-179-103.33 103.33-178L576-248l-57.67 100q126-14.33 210.5-109t84.5-223q0-17.67-1.83-33.83-1.83-16.17-5.83-32.84H874q3 16.67 4.5 33.17T880-480q0 140.33-86.5 249.17Q707-122 571.33-90.33L628-57 594.67 0Z" />
      </svg>
    </SvgIcon>
  );
};

export default Cycle;
